import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { usePreserveSearch } from '../../../../Hooks/usePreserveSearch';
import { SignInNoticeKey } from '../../i18n';
import { useChatStrings } from '../../stringsContext';
import { InfoIcon } from '../Icons';
import GoogleAuthSection from './GoogleAuthSection';

interface UserDetailsCardProps {
   /** Receives the Google-signed ID token from "Sign in with Google". */
   onGoogleAuth: (idToken: string) => Promise<void>;
   /** Why the guest is back at the front door (an expired session, a different hotel's link). */
   noticeKey?: SignInNoticeKey;
}

/**
 * The front door. Guests sign in with Google only: Google has verified the email, so nobody can open another
 * guest's conversation. On the tokens for now; its own composition is a later surface (PRODUCT.md).
 */
const UserDetailsCard: React.FC<UserDetailsCardProps> = ({ onGoogleAuth, noticeKey }) => {
   const strings = useChatStrings();
   const { privacyPath } = usePreserveSearch();
   const [isLoading, setIsLoading] = useState(false);

   const handleGoogleAuth = async (idToken: string) => {
      setIsLoading(true);
      try {
         await onGoogleAuth(idToken);
      } finally {
         setIsLoading(false);
      }
   };

   return (
      <section className="cx-tile cx-frosted cx-frosted--thick cx-signin" aria-label={strings.signInTitle()}>
         {noticeKey && (
            <p className="cx-signin__notice" role="status">
               <InfoIcon />
               <span>{strings[noticeKey]}</span>
            </p>
         )}
         <div>
            <h2 className="cx-signin__title">{strings.signInTitle()}</h2>
            <p className="cx-signin__body">{strings.signInBody}</p>
         </div>
         <GoogleAuthSection onGoogleAuth={handleGoogleAuth} isLoading={isLoading} />
         <p className="cx-signin__foot">
            <Link to={privacyPath}>{strings.privacy}</Link>
         </p>
      </section>
   );
};

export default UserDetailsCard;
